<template>
  <div v-show="show">
    <app-alert
      :active.sync="exportingLocal"
      closable
      color="primary"
      bgColor="bg-blue-50"
      icon-pack="feather"
      icon="icon-clock"
      close-icon="icon-x"
      type="linear-center"
      >
      {{ $t(`${messagePrefix}.ExportingMsg`, { entity: this.entity }) }}
    </app-alert>

    <app-alert
      :active.sync="exportedLocal"
      closable
      color="success"
      bgColor="bg-green-50"
      icon-pack="feather"
      icon="icon-check"
      close-icon="icon-x"
      type="linear-center"
      >
      <span v-html="$t(`${messagePrefix}.ExportedMsg`, {
        entity: this.entity, url: this.fileUrl
      })">
      </span>
    </app-alert>
  </div>
</template>

<script>
import AppAlert from '@/views/_components/AppAlert.vue';

/**
 * Component to show exporting alert messages
 *
 * @module views/modules/components/ExportAlertInfo
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 */
export default {
  name: 'ExportAlertInfo',
  components: {
    AppAlert,
  },
  i18n: {
    messages: {
      en: {
        WithEmail: {
          ExportingMsg: 'Your {entity} are being exported. Once they are ready, you will receive a file by email. You can also download your file directly.',
          ExportedMsg: 'Your {entity} have been exported successfully, and you will receive a file by email. You may also download your file directly from <a class="ml-0 link-contextual" href="{url}">here</a>.',
        },
        WithoutEmail: {
          ExportingMsg: 'Your {entity} are being exported. Once they are ready, you will download your file directly.',
          ExportedMsg: 'Your {entity} have been exported successfully, and you may download your file directly from <a class="ml-0 link-contextual" href="{url}">here</a>.',
        },

      },
    },
  },
  props: {
    exporting: {
      type: Boolean,
      required: false,
      default: false,
    },
    exported: {
      type: Boolean,
      required: false,
      default: false,
    },
    sendEmail: {
      type: Boolean,
      required: false,
      default: false,
    },
    entity: {
      type: String,
      required: true,
    },
    fileUrl: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      exportingLocal: this.exporting,
      exportedLocal: this.exported,
    };
  },
  computed: {
    show() {
      return this.exporting || this.exported;
    },
    messagePrefix() {
      return this.sendEmail ? 'WithEmail' : 'WithoutEmail';
    },
  },
  watch: {
    exporting(val) {
      if (val) {
        this.exportedLocal = false;
      }

      this.exportingLocal = val;
    },
    exported(val) {
      if (val) {
        this.exportingLocal = false;
      }

      this.exportedLocal = val;
    },
    exportingLocal(val) {
      if (!val) {
        this.$emit('update:exporting', false);
      }
    },
    exportedLocal(val) {
      if (!val) {
        this.$emit('update:exported', false);
      }
    },
  },
};
</script>
